import type { ConfirmDialog as PrimeConfirmDialog } from "primereact/confirmdialog";
import { forwardRef } from "react";

import type { ConfirmDialogProps } from "./types-confirm-dialog";
import { useConfirmDialog } from "./use-confirm-dialog";
import { ConfirmDialogView } from "./view-confirm-dialog";

/**
 * `ConfirmDialog` do Prime com o visual do Figma (título 600, ícone centralizado, Cancelar outlined) e o `accept` assíncrono:
 * enquanto a Promise não resolve o botão carrega e o diálogo trava; ao rejeitar, o erro aparece dentro dele.
 * O `ref` é a instância do Prime.
 */
export const ConfirmDialog = forwardRef<PrimeConfirmDialog, ConfirmDialogProps>(
  function ConfirmDialog(props, ref) {
    const viewModel = useConfirmDialog(props);

    return <ConfirmDialogView dialogRef={ref} {...viewModel} />;
  },
);
ConfirmDialog.displayName = "ConfirmDialog";
